import Cargos from '@/models/Cargos'

export default [
  {
    path: '/atendimento/painel',
    name: 'rota-painel',
    autenticado: true,
    cargo: [Cargos.ATENDENTE, Cargos.BARBEIRO_CAIXA, Cargos.LIDER],
    titulo: 'Painel atendimento',
    layout: 'LayoutBarraLateral',
    menu: {
      label: 'Atendimentos',
      icon: 'columns',
    },
    component: () => import(/* webpackChunkName: "painel" */ '../views/painel/Painel.vue'),
  },
]
